import React from 'react';
import { Container, Fade } from 'reactstrap';
import { completeCarePlanActivity } from '../../apis/carePlan';
import { useCarePlan } from '../../contexts/carePlan';
import { usePractitioner } from '../../contexts/practitioner';
import { WizardPage } from '../../modules/unsw-wizard';
import { PageContext } from '../../modules/unsw-wizard/Contexts/PageContext';
import MyChoice from '../Cards/MyChoice';
import { WizardQuestionnaire } from '../Questionnaires';
import './index.css';

const InterviewReview = () => (
  <WizardPage
    name="5"
    title="My Choices"
    subTitle="Please review results"
    disabled
    activeAfterComplete>
    <PageContext.Consumer>
      {({ onComplete }) => (
        <Container fluid className="mt-3 mb-3">
          <MyChoice onComplete={onComplete} />
        </Container>
      )}
    </PageContext.Consumer>
  </WizardPage>
);

const InterviewPersonalValues = () => {
  const carePlanConext = useCarePlan();
  const practitionnerContext = usePractitioner();
  const practitionerId =
    (practitionnerContext.practitioner &&
      practitionnerContext.practitioner.id) ||
    undefined;
  return (
    <Fade>
      {practitionerId && (
        <WizardQuestionnaire
          pageId="1"
          name="patient_values"
          disabled
          onComplete={async (questionnaire, response) => {
            if (carePlanConext.carePlan && response) {
              const mCarePlan = await completeCarePlanActivity(
                carePlanConext.carePlan,
                questionnaire.id!,
                response.id!,
              );
              await carePlanConext.setCarePlan(mCarePlan);
            }
          }}
        />
      )}
    </Fade>
  );
};
const Interview = () => (
  <>
    <InterviewPersonalValues />
    <InterviewReview />
  </>
);

export default Interview;
